import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ProductCard from "../ProductCard/ProductCard";

const rubikfont = { fontFamily: "Rubik, sans-serif" };

// Layout 4: "Trending". Ranked products in a scrolling row, each under a big outlined number.
const Layout4 = ({ data }) => {
    const products = (data?.product_id || []).slice(0, 12);
    const navigate = useNavigate();
    const viewAll = () => navigate(`/search?layoutId=${data._id}&title=${encodeURIComponent(data.title)}`);

    return (
        <Box sx={{ py: { xs: 1.5, md: 2.5 } }}>
            <Container maxWidth="xl">
                <Box sx={{ mb: 2.5, p: { xs: 1.75, md: 2.25 }, borderRadius: "16px", bgcolor: "#fff4ef", border: "1px solid #ffd9cc", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: "#ff3d00", animation: "tvfmPulse 1.5s infinite" }} />
                        <Box>
                            <Typography sx={{ fontSize: "11px", fontWeight: 700, letterSpacing: "3px", color: "#ff3d00", textTransform: "uppercase", ...rubikfont }}>
                                {data?.subtitle || "Trending now"}
                            </Typography>
                            <Typography sx={{ fontSize: { xs: "22px", sm: "28px" }, fontWeight: 800, color: "#111", fontFamily: "'Playfair Display', serif", lineHeight: 1.1 }}>
                                {data?.title}
                            </Typography>
                        </Box>
                    </Box>
                    <Typography onClick={viewAll} sx={{ fontSize: "12px", fontWeight: 600, color: "#ff3d00", cursor: "pointer", letterSpacing: "1.5px", textTransform: "uppercase", "&:hover": { textDecoration: "underline" }, ...rubikfont }}>
                        See the full list →
                    </Typography>
                </Box>

                <Box sx={{ display: "flex", gap: { xs: 1.5, md: 2.5 }, overflowX: "auto", pb: 1.5, scrollbarWidth: "thin", scrollbarColor: "#ff3d00 #f3f3f3", "&::-webkit-scrollbar": { height: 4 }, "&::-webkit-scrollbar-thumb": { background: "#ff3d00", borderRadius: 2 } }}>
                    {products.map((product, i) => (
                        <Box key={product._id} sx={{ flex: "0 0 auto", width: { xs: 160, sm: 190, md: 215 } }}>
                            <Typography
                                sx={{
                                    fontSize: { xs: "44px", md: "56px" },
                                    fontWeight: 800,
                                    lineHeight: 0.9,
                                    mb: 0.5,
                                    color: "transparent",
                                    WebkitTextStroke: "1.5px #ff3d00",
                                    fontFamily: "'Playfair Display', serif",
                                    userSelect: "none",
                                }}
                            >
                                {String(i + 1).padStart(2, "0")}
                            </Typography>
                            <ProductCard product={product} />
                        </Box>
                    ))}
                </Box>
            </Container>
            <style>{`@keyframes tvfmPulse { 0% { opacity: 0.5; transform: scale(0.9); } 50% { opacity: 1; transform: scale(1.25); } 100% { opacity: 0.5; transform: scale(0.9); } }`}</style>
        </Box>
    );
};

export default Layout4;
